export default "__VITE_ASSET__CK0wZvy6__"